import { FieldError } from '@components/field-error';
import { Select, SelectProps } from 'antd';
import clsx from 'clsx';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

type AppSelectProps<T extends FieldValues> = SelectProps & {
  required?: boolean;
  label?: string;
  name: Path<T>;
  placeholder?: string;
  control: Control<T>;
  suffixLabel?: React.ReactNode;
  'data-test-id'?: string;
};

export function AppSelect<T extends FieldValues>(props: AppSelectProps<T>) {
  const {
    required,
    label,
    name,
    placeholder,
    suffixLabel,
    control,
    className,
    'data-test-id': dataTestId,
    ...restProps
  } = props;
  const _placeholder = placeholder || '- ' + 'Select' + '-';

  return (
    <div className="flex flex-col gap-1.5 w-full">
      <p className="text-base leading-5	font-medium	text-text-800">
        {label} <span className="text-text-400 text-sm font-normal">{suffixLabel && suffixLabel}</span>{' '}
        {required && <span className="text-red-500">*</span>}
      </p>

      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          return (
            <div className="w-full flex flex-col gap-1.5" data-test-id={dataTestId}>
              <Select
                className={clsx('app-select', className)}
                status={error && 'error'}
                size="large"
                title={label}
                value={value}
                onChange={onChange}
                placeholder={_placeholder}
                {...restProps}
              />
              <FieldError message={error?.message} />
            </div>
          );
        }}
      />
    </div>
  );
}
